<template>
  <div v-if="show" class="agreement-list">
    <h4>Agreements</h4>

    <div class="agreement-list">
      <hg-agreement-list-record
        v-for="agreement in signedAgreements"
        :key="agreement.id"
        :link="agreement.link"
        :signedDate="agreement.signed"
        :status="agreement.status"
        :title="agreement.title" />
    </div>

    <router-link
      v-if="hgFolderStatus.canSignAgreements"
      class="btn-tertiary agreement-link"
      :to="linkRoute">{{linkName}}</router-link>
    <span v-else>{{linkName}}</span>
  </div>
</template>

<script>
import AgreementListRecord from './AgreementListRecord.vue';

export default {
  components: {
    'hg-agreement-list-record': AgreementListRecord,
  },
  props: {
    hgAgreements: {
      type: Array,
      required: true,
    },
    hgFolderId: {
      type: String,
      required: true,
    },
    hgFolderStatus: {
      type: Object,
      required: true,
    },
    hgCompanyId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    linkName() {
      if (!this.hgFolderStatus.canSignAgreements) return 'At least one agreement needs your signature, but you do not have permission. Please contact your inspector.';

      if (this.hgFolderStatus.signatureNeeded) return 'View and sign all agreement(s)';

      return 'View all agreement(s)';
    },
    linkRoute() {
      return `/company/${this.hgCompanyId}/agreements/${this.hgFolderId}`;
    },
    signedAgreements() {
      return this.hgAgreements.filter(agreement => agreement.dateSigned !== '');
    },
    show() {
      return this.hgFolderStatus.signatureNeeded || this.hgAgreements.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

h4 {
  color: $theme-color-gray;
  font-size: 1.143rem;
  margin-bottom: 10px;
}

h5 {
  color: rgba($theme-color-black, 0.65);
  font-size: 1.07rem;
  font-weight: $typography-weight-bold;
}

p {
  padding-bottom: 0;
}

.agreement-link {
  font-size: 1.07rem;
}

.agreement-text {
  color: rgba($theme-color-black, 0.6);
  font-size: 1.143rem;
}

.agreement-list {
  border-bottom: solid 1px rgba($theme-color-black, 0.15);
  margin-bottom: 10px;
}
</style>
